import React from 'react';

import { Outlet } from 'react-router-dom';
const MaintanceMngPage = () => {
  return <Outlet />;
};

export default MaintanceMngPage;
